export default __webpack_public_path__ + "static/media/amparo-arte-7.aa9aa692.webp";